import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { ColumnBuilderComponent } from './column-builder.component';

@NgModule({
  declarations: [
    ColumnBuilderComponent
  ],
  exports: [ColumnBuilderComponent],
  imports: [
    CommonModule,
    NzCheckboxModule,
    NzIconModule,
    FormsModule
  ]
})
export class ColumnBuilderModule { }
